import React from 'react'
import { CrudEventEnum, EntityTypeEnum, OrganisationPrimeBrokerDetail, WorkflowActions } from 'api'
import { useDispatch, useSelector } from 'react-redux'
import { tradingEntityMetaGetterSelector } from 'selectors/tradingEntitySelectors'
import { ActionsButtonProps } from 'view/components/datagrid'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { PrimeBrokerDefaultsAddDialog } from '../PrimeBrokerDefaultsAddDialog'
import { createTradingEntityUpdateMetaAction } from 'model/tradingEntityMetaUtils'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import { Locale, Translation } from 'locale'

interface PrimeBrokerDefaultsActionsButtonProps extends ModalConsumerProps, ActionsButtonProps<OrganisationPrimeBrokerDetail> {}

export const PrimeBrokerDefaultsActionsButton = withModal((props: PrimeBrokerDefaultsActionsButtonProps) => {
  const dispatch = useDispatch()
  const getMeta = useSelector(tradingEntityMetaGetterSelector)

  function onEdit() {
    const [primeBrokerDetail] = props.items

    dispatch(
      WorkflowActions.createEditWorkflow(EntityTypeEnum.TRADING_ENTITY_META, primeBrokerDetail.id, (workflowId: string) => {
        props.showModal(<PrimeBrokerDefaultsAddDialog workflowInfo={{ workflowId, metaId: primeBrokerDetail.id }} />)
      })
    )
  }

  function onDelete() {
    props.items.forEach(primeBrokerDetail => {
      const meta = getMeta(primeBrokerDetail.ownerTradingEntity.id, primeBrokerDetail.subjectTradingEntity.id)

      if (meta?.id) {
        dispatch(
          createTradingEntityUpdateMetaAction({
            ...meta,
            primeBrokerId: null
          })
        )
      }
    })
  }

  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_EDIT),
      onClick: onEdit,
      enabled: props.items.length === 1 && props.items.every(i => i.availableEvents.includes(CrudEventEnum.UPSERT))
    },
    {
      label: Locale.translate(Translation.TC_ACTION_DELETE),
      onClick: onDelete,
      enabled: props.items.every(i => i.availableEvents.includes(CrudEventEnum.DELETE))
    }
  ]

  return <SplitButtonDropdown dataTestId={props.dataTestId} actions={actions} maxButtons={1} />
})
